import { createReducer, on } from '@ngrx/store';
import { IngestionAnalysisActions } from '../../actions/generations/doc-analysis';
import { GenerationActions } from '../../actions/generations/generation.actions';

interface IngestionAnalysisState {
  ingestionAnalysis: any;
}

const initialState: IngestionAnalysisState = {
  ingestionAnalysis: []
};
const ingestionAnalysisReducer = createReducer(
  initialState,
  on(IngestionAnalysisActions.setIngestionAnalysis, (state, { data }) => {
    return {
      ...state,
      ingestionAnalysis: [...data]
    };
  }),
  on(IngestionAnalysisActions.clearIngestionAnalysis, (state) => {
    return {
      ...state,
      ingestionAnalysis: []
    };
  }),
  on(GenerationActions.resetGeneration, (state) => ({
    ...initialState
  }))
);

export { ingestionAnalysisReducer, IngestionAnalysisState };
